"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrivacyPolicyPage = PrivacyPolicyPage;
var jsx_runtime_1 = require("react/jsx-runtime");
var legal_page_layout_1 = require("../components/legal/legal-page-layout");
var privacy_policy_data_1 = require("../data/privacy-policy.data");
function PrivacyPolicyPage() {
    return (0, jsx_runtime_1.jsx)(legal_page_layout_1.LegalPageLayout, { legalDocument: privacy_policy_data_1.PRIVACY_POLICY });
}
